import { type FC, type ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import cn from 'classnames';

import dibsCss from 'dibs-css';

import { getByDocCreator } from '../../shared/getByDocCreator';
import {
    useItemTranslations,
    INTERFACE_STATE,
} from '../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider';

import { type PdpRespTitle_item$key } from './__generated__/PdpRespTitle_item.graphql';

type Props = {
    item: PdpRespTitle_item$key;
    isPDPDesktopAggregationVariant?: boolean | null;
    isUnavailablePdp?: boolean;
    isPdpPricingAndSaleVariant?: boolean;
};

export const PdpRespTitle: FC<Props> = ({
    item: itemRef,
    isPDPDesktopAggregationVariant,
    isUnavailablePdp,
    isPdpPricingAndSaleVariant,
}) => {
    const item = useFragment(
        graphql`
            fragment PdpRespTitle_item on Item {
                title
                isArt
                classification {
                    creationDate
                }
                ...getByDocCreator_item
            }
        `,
        itemRef
    );
    const { isArt, title, classification } = item || {};

    let artCreator = null;
    let artCreationDate = null;
    const [state] = useItemTranslations();
    let itemTitle: string | ReactNode =
        state?.interfaceState === INTERFACE_STATE.SHOW_ORIGINAL
            ? state?.data?.viewer?.item?.title
            : title;

    if (isArt) {
        itemTitle = (
            <span className={dibsCss.sassyFontHeaderMediumItalic} data-tn="pdp-item-title">
                {itemTitle}
            </span>
        );

        const creationDate = classification?.creationDate;
        if (creationDate) {
            artCreationDate = (
                <p className={dibsCss.sassyFontHeaderMedium} data-tn="pdp-item-creation-date">
                    {creationDate}
                </p>
            );
        }

        artCreator = getByDocCreator({ item });
    }

    return (
        <h1
            className={cn(dibsCss.sassyFontHeader, dibsCss.m0, dibsCss.mbSmall, {
                [dibsCss.mbXsmall]:
                    (isPDPDesktopAggregationVariant || isUnavailablePdp) &&
                    !isPdpPricingAndSaleVariant,
                [dibsCss.sassyFontHeaderMedium]: isUnavailablePdp && !isPdpPricingAndSaleVariant,
                [dibsCss.mbSmaller]: isPdpPricingAndSaleVariant,
            })}
            data-tn="pdp-resp-title"
        >
            {artCreator}
            <div data-tn="pdp-main-title">
                {itemTitle}
                {artCreationDate}
            </div>
        </h1>
    );
};
